import { Pipe, PipeTransform } from '@angular/core';
import { SingleImageInWallDecorMap } from '@ui/look-book-front/wall-decor-front/types';

@Pipe({
    name: 'usedBefore',
    standalone: false
})
export class UsedBeforePipe implements PipeTransform {
  transform(
    value: string,
    otherImages: Record<string, SingleImageInWallDecorMap>
  ): number {
    if (!otherImages) {
      return 0;
    }
    return Object.values(otherImages).filter((v) => v.photoId === value).length;
  }
}
